import {SmartComponent} from "smart-component-js";
import InviteFriendModalComponent from "./InviteFriendModalComponent";

class InviteFriendCodeComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.code = this.element.dataset.code || '';
        this.userCount = this.element.dataset.userCount || 0;
        this.init();
    }

    openShareModal() {
        const shareButton = this.element.querySelector(".friend-code__share");
        if (!shareButton) return;

        const rewardModal = new InviteFriendModalComponent(this.code);
        shareButton.addEventListener("click", () => {
            rewardModal.startModal();
        });
    }

    // populateFriendData() {
    //     const codeElement = this.element.querySelector(".friend-code__copy-code");
    //     const amountElement = this.element.querySelector(".friend-code__amount-details");
    //     if (codeElement) codeElement.textContent = this.code;
    //     if (amountElement) amountElement.textContent = `${this.userCount} amici`;
    // }


    copyFriendCode() {
        const codeElement = this.element.querySelector(".friend-code__copy-code");
        codeElement?.addEventListener('click', () => {
            const messageElement = document.getElementById("copy-message");
            const codeText = codeElement.innerText;

            navigator.clipboard.writeText(codeText).then(() => {
                    codeElement.classList.add("copied");
                    messageElement.innerText = "Codice copiato!";
                    messageElement.style.display = "block";

                    setTimeout(() => {
                        codeElement.classList.remove("copied");
                        messageElement.style.display = "none";
                    }, 2000);
                })
                .catch(err => console.error("Errore nella copia:", err));
        });
    }


    init() {
        // this.populateFriendData();
        this.openShareModal();
        this.copyFriendCode();
    }
}

export default InviteFriendCodeComponent;
